import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GetListNewBO } from './list.model';

@Injectable({
    providedIn: 'root'
})
export class ListDateService extends Subject<DataStateChangeEventArgs> {
    constructor(private http: HttpClient, public errorService: ErrorService) {
        super();
    }
    public execute(ListState: GetListNewBO): void {
        this.getListFilter(ListState).subscribe(x => super.next(x));
    }
    getListFilter(ListState?: GetListNewBO): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/List/GetLists", ListState)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count']
                    }
            ))
    }
}
